// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import {
  SelectOrganization,
  UpdateOrganizationProfile,
} from '@actions/organization';
import { AccountLogout } from '@actions/account';

interface OrganizationProfile {
  _id?: string;
  organizationId?: string;
  [key: string]: unknown;
}

interface SelectedOrganization {
  _id: string;
  profile?: OrganizationProfile;
  [key: string]: unknown;
}

type SelectedOrganizationState = SelectedOrganization | null;

type SelectOrganizationAction = Action<SelectedOrganization>;
type UpdateOrganizationProfileAction = Action<OrganizationProfile>;

const initialState: SelectedOrganizationState = null;

export default handleActions<
  SelectedOrganizationState,
  SelectedOrganization | OrganizationProfile | string | void
>(
  {
    [SelectOrganization.toString()]: (
      _: SelectedOrganizationState,
      { payload }: SelectOrganizationAction,
    ): SelectedOrganizationState => payload,
    [UpdateOrganizationProfile.toString()]: (
      state: SelectedOrganizationState,
      { payload }: UpdateOrganizationProfileAction,
    ): SelectedOrganizationState =>
      ({
        ...state,
        profile: payload,
      } as SelectedOrganization),
    [AccountLogout.toString()]: (): SelectedOrganizationState => initialState,
  },
  initialState,
);
